define('core/global/analytics',["jquery", "core/global/state", "libs/jquery.bbq", "waypoints"], function ($, state) {
    console.log('global/analytics');

    // This file needs to pull in some vars that are set in _Layout, so using loose module pattern coupling 
    var me = (function (ns) {
        ns.liveballURLPrefix = "landing.";

        /***************** Add DMS visit ID to all liveball links *****************/
        ns.sendToLiveball = function () {
            // get all links to liveball
            var $links = $('a[href*="' + ns.liveballURLPrefix + '"]');

            // loop through each link
            $links.each(function () {
                var $this = $(this),
                    url = $this.attr('href'),
                    data = {},
                    newUrl;

                // create object of key/value pairs to append to existing url
                data.visit = ns.visitId;
                data.visitor = ns.visitorId;

                // create new url

                newUrl = $.param.querystring(url, data);

                // set url
                $this.attr('href', newUrl);
            });
        };

        //************ Scroll Depth Tracking ******************
        ns.trackScrollDepth = function () {

            function recordSdEvent(trackid) {
                dataLayer.push({ 'event': 'scroll', 'reference': '' + trackid + '' });
            }

            // Waypoints blows up ie8
         
            if (!state.oldIe()) {
                var waypoint = new Waypoint({
                    element: document.querySelector('.sd-unit'),
                    handler: function (direction) {
                        recordSdEvent($(this).data('analyticsid'));
                    },

                    triggerOnce: true,
                    offset: "bottom-in-view"

                });
            }
        };

        //************ SEND ORIENTATION TO GA ******************
        ns.sendOrientationToGA = function() {
            // send device orientation to ga 
            if (window.getComputedStyle) { // if the browser doesn't support getComputedStyle, skip this because it will crash
                var orientation = window.getComputedStyle(document.body, ':before').getPropertyValue('content');
                if (orientation.indexOf("portrait") != -1)
                    dataLayer.push({ 'event': 'load', 'orientation': 'portrait' });

                if (orientation.indexOf("landscape") != -1)
                    dataLayer.push({ 'event': 'load', 'orientation': 'landscape' });
            }
        };

        //************** FIRE JS ON LOAD OF ANCHOR TAG ***********
        // Used for GA Tracking of A/B Tested links
        ns.fireDataOnloadOnAnchor = function() {
            $("a[data-onload]").each(function(i) {
                var x = ($(this).attr('data-onload'));
                var func;

                // substring - to get datalayer param
                if (x) {
                    var startIndex = x.indexOf("(");
                    var endIndex = x.indexOf(")");
                    var functionName = x.substring(0, startIndex);
                    var param = x.substring(startIndex + 1, endIndex);

                    // replacing ' with " in param
                    var arr1 = param.split("'");
                    var arr2 = arr1.join('"');

                    // converting param string to object
                    var obj = JSON.parse(arr2);
                }

                if (functionName) {
                    temp = functionName.split('.');
                    il = temp.length;
                    context = null;

                    for (i = 0; i < il; i++) {
                        if (func == null) {
                            func = window[temp[i]];

                            if (typeof (func) !== "function") {
                                context = func;
                            }
                            continue;
                        }
                        func = func[temp[i]];
                    }

                    // function call 
                    func.call(context, obj);
                }
            });
        };

        return ns;
    }(window.EFTOURS.analytics || {}));

    return me;
});
